import React, { Component, Fragment } from "react";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "./../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import VisitPreview from "./../../../components/visit/Preview";
import MenuActivite from "../Menu";

class Preview extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftIndex("visits");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return (
      <Fragment>
        <VisitPreview />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);



// WEBPACK FOOTER //
// src/pages/activite/visit/Preview.js